import FeatureGates from "@atlaskit/feature-gate-js-client";
import UFOSegment from "@atlaskit/react-ufo/segment";

import { Adg4SectionDivider } from "@/components/adg4/section-divider/src";
import { TypographyStyles } from "@/libraries/wpl/foundations/src";
import { GlobalFooter } from "@/patterns/global-footer/src";

import {
    BadgesSection,
    CarouselSection,
    CtaSection,
    DataCenterSection,
    EnterprisePageProductNav,
    GartnerDisclaimer,
    HeroSection,
    HeroEnterpriseTakeoverTurbo,
    HeroV2Section,
    PlatformSection,
    ResourcesSection,
    StatsSection,
    SupportSection,
    TabsSection
} from "./sections";

export const EnterpriseLandingPageTemplate = () => {
    const shouldShowHeroV2 = FeatureGates.getExperimentValue(
        "wac-enterprise-hero-v2",
        "value",
        false
    );

    return (
        <UFOSegment name="enterprise-page">
            <TypographyStyles>
                <EnterprisePageProductNav isActive="overview" />
                <HeroEnterpriseTakeoverTurbo />
                {shouldShowHeroV2 ? <HeroV2Section /> : <HeroSection />}
                {shouldShowHeroV2 ? null : <BadgesSection />}
                <TabsSection />
                <CarouselSection />
                <PlatformSection />
                <StatsSection />
                <ResourcesSection />
                <Adg4SectionDivider bgColor="#F0F1F2" />
                <SupportSection />
                <DataCenterSection />
                <CtaSection />
                <GartnerDisclaimer />
            </TypographyStyles>
            <GlobalFooter />
        </UFOSegment>
    );
};
